import React from "react";
import Skeleton from "./skeleton.component";

export default function TrackSkeloton() {
  return <Skeleton times={5} className=" h-[calc(58px+6.076vw)] rounded-xl" />;
}
